var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPluses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 185,
    viewBox: "0 0 182 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006065"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ornament 57",
    d: "M120.059 40.5334H148.559V73.7836L181.81 73.7836L181.81 102.284H148.559V135.534H120.059V102.284H86.8091V73.7836H120.059V40.5334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ornament 58",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1528 -0.00012207H47.3788V23.5968H70.9757V43.8227H47.3788V67.4196H27.1528V43.8227H3.55595V23.5968H27.1528V-0.00012207ZM43.8648 27.1108H67.4617V47.3367H43.8648V70.9336H23.6389V47.3367H0.0419846V27.1108H23.6389V3.51388H43.8648V27.1108ZM42.5981 4.78056V28.3775H66.195L66.195 46.07H42.5981V69.6669H24.9056V46.07H1.30865V28.3774H24.9056V4.78056H42.5981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ornament 59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1217 130.858L17.2525 111.988L2.51731 126.723L21.3866 145.593L22.6452 146.851L21.3866 148.11L2.51731 166.979L17.2525 181.714L36.1217 162.845L37.3804 161.587L38.639 162.845L57.5083 181.714L72.2434 166.979L53.3742 148.11L52.1155 146.851L53.3742 145.593L72.2434 126.723L57.5083 111.988L38.639 130.858L37.3804 132.116L36.1217 130.858Z",
    stroke: "white",
    strokeWidth: 3.56004
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1217 130.858L17.2525 111.988L2.51731 126.723L21.3866 145.593L22.6452 146.851L21.3866 148.11L2.51731 166.979L17.2525 181.714L36.1217 162.845L37.3804 161.587L38.639 162.845L57.5083 181.714L72.2434 166.979L53.3742 148.11L52.1155 146.851L53.3742 145.593L72.2434 126.723L57.5083 111.988L38.639 130.858L37.3804 132.116L36.1217 130.858Z",
    stroke: "url(#paint0_linear_295_27991)",
    strokeWidth: 3.56004
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_295_27991",
    x1: 37.3804,
    y1: 109.471,
    x2: 37.3804,
    y2: 184.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluses);
export default __webpack_public_path__ + "static/media/pluses.636d60d1d2e639326176473e1465820e.svg";
export { ForwardRef as ReactComponent };